import React, {  useState } from "react";
import DeviceGridTable from "../../../layouts/DeviceGridTable";


const Devices = () => {

  return (
    <>
      {/* CRUD Data Grid */}
      <DeviceGridTable />
    </>
  );
};

export default Devices;
